import React, { useState } from 'react';
import {
  FollowUpKind,
  FollowUpModel,
  QqFollowUpModel,
} from '@mm/state/model/FollowUpModel';
import { GenericFollowUpItem } from './GenericFollowUpItem/GenericFollowUpItem';
import { landmineNames } from '@mm/constants/landmine-names';

type Props = {
  records: FollowUpModel<QqFollowUpModel>[];
  kind: FollowUpKind;
  headingNote: string;
  landmineName: keyof typeof landmineNames;
  hideWidgetAdder: boolean;
  thenSelector: React.ReactNode;
  bottomNote?: React.ReactNode;
  showTimeWarning?: boolean;
};

export const GenericFollowUps = (props: Props) => {
  const {
    records,
    kind,
    headingNote,
    landmineName,
    hideWidgetAdder,
    showTimeWarning,
    bottomNote,
    thenSelector,
  } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div>
      {records
        .sort(record => record.sortOrder)
        .map((record: FollowUpModel<QqFollowUpModel>, index: number) => (
          <GenericFollowUpItem
            thenSelector={thenSelector}
            showTimeWarning={showTimeWarning}
            hideWidgetAdder={hideWidgetAdder}
            index={index}
            key={index}
            kind={kind}
            bottomNote={bottomNote}
            headingNote={headingNote}
            landmineName={landmineName}
            record={record}
            active={index === activeIndex}
            onToggleActive={record =>
              setActiveIndex(records.findIndex(r => r.id === record?.id) || 0)
            }
          />
        ))}
    </div>
  );
};
